import { Component, Input } from '@angular/core';
import { RRBreadcrumbModel } from '../../models/breadcrumb.model';

@Component({
  selector: 'rr-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent {
  @Input() breadcrumbs: RRBreadcrumbModel[];

  constructor() {}
}
